<template>

  <SubHeading :home="home" :tabs="tabs" :shorts="false" :currTab="currTab" @active="handleActive" />

  <!-- Loader -->
  <div class="progress container" v-if="isLoading && isReady">
    <div class="indeterminate"></div>
  </div>

  <!-- search layer -->
  <!-- <div class="grey lighten-4">
    <div class="container section"></div>
  </div> -->

  <!-- breadcrumbs -->
  <nav class="sba-collection-breadcrumb z-depth-0">
    <div class="container nav-wrapper">
      <div class="sba-collection-breadcrumb-row">
        <router-link to="/" class="breadcrumb sba-collection-crumb teal-text">
          <i class="material-icons">home</i>
          <span>Dashboard</span>
        </router-link>
        <i class="material-icons sba-collection-crumb-separator">chevron_right</i>
        <span class="breadcrumb sba-collection-crumb blue-grey-text pointable">
          <span>Providers</span>
        </span>
        <span class="sba-collection-context">Provider Register</span>
      </div>
    </div>
  </nav>


  <!-- View Marker -->
  <div id="view"></div>

  <!-- Main -->
  <div class="sba-collection-page-surface is-workbench provider-page-surface">
  <div class="container">

    <!-- Providers -->
    <LoadingDiv v-if="!isReady" />

    <div v-else>

      <!-- <div class="black-text center" v-if="!syncInc">
        <br />
        <h5 v-if="searchItem">
          <span class="black blue-text chip">Search <i class="tiny material-icons">check_circle</i></span>
          <span class="yellow lighten-2 black-text chip"><em>{{ searchItem }}</em></span>
        </h5>
        <h5 v-else>
          <span class="black blue-text chip">Display <i class="tiny material-icons">check_circle</i></span>
          <span class="yellow lighten-2 black-text chip"><em>All Providers</em></span>
        </h5>
      </div> -->

      <div class="section provider-client-surface sba-slide-in">
        <div class="provider-review-head">
          <div class="provider-title-block">
            <label class="active teal-text">Providers</label>
            <h5>Provider Register</h5>
            <p>Search, open, and manage healthcare provider records from one focused register.</p>
          </div>
          <router-link :to="{ name: 'providerAdd' }" class="provider-add-link">
            <span>Add Provider</span>
            <i class="material-icons">add_circle</i>
          </router-link>
        </div>

        <div class="provider-search-card">
          <form>
            <div class="input-field">
              <input id="search" type="search" v-model="searchItem" placeholder="Search provider by name or address" autocomplete="off">
              <label class="label-icon" for="search"><i class="material-icons">search</i></label>
              <i class="material-icons" @click="handleClearSearch" v-if="searchItem">clear</i>
            </div>
          </form>
        </div>

        <div class="provider-search-status" v-if="searchItem">
          <div>
            <span>Search active</span>
            <strong>{{ searchItem }}</strong>
          </div>
          <button type="button" @click="handleClearSearch" title="clear search">
            <i class="material-icons">close</i>
          </button>
        </div>

     <!-- Display -->
        <div class="card z-depth-0 provider-client-card" v-for="provider in providers" :key="provider.id">

          <div class="card-content">
            <h5>
              <span class="new badge" data-badge-caption="claims" v-if="provider.status === 'a'">{{
                `${provider.encounters_count
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                }}</span>
              <span class="new badge red darken-1" data-badge-caption="Provider"
                v-else-if="provider.status === 's'">Inactive</span>
              <span class="new badge orange darken-1" data-badge-caption="Approval" v-else>Pending</span>
              <router-link :to="{ name: 'providerView', params: { id: provider.id } }">{{ provider.name }}</router-link>
            </h5>
            <p><span v-if="provider?.phone">{{ provider.phone }} </span> <span v-if="provider?.email">{{ provider.email
            }}</span>
            </p>
          </div>

        </div>
      </div>

      <div class="section center provider-empty-state" v-if="!providers.length">
        <i class="material-icons">medical_services</i>
        <h6>No providers found</h6>
        <p>There are no provider records matching this view.</p>
      </div>

      <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-else />
    </div>
  </div>
  </div>
</template>

<script>
import { computed, onMounted, ref, watch, watchEffect } from "vue";
import useModuleNavigation from "@/composables/useModuleNavigation";
import getItems from "@/composables/getItems";
import SubHeading from "@/components/HeaderSubDiv.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import PaginationDiv from "@/components/pager/PaginationDiv.vue";
import { debounce, getCachedPayload, setCachedPayload } from "@/composables/requestOptimization";


export default {
  name: "providerHome",
  components: { SubHeading, LoadingDiv, PaginationDiv },
  setup() {
    const syncInc = ref(0);
    const pendingRegistrationInc = ref(0);
    const response = ref(null);
    const isReady = ref(false);
    const isLoading = ref(true);
    const currUrl = ref(null);
    const currHook = ref(null);
    const error = ref(null);
    const searchItem = ref(null);
    const home = ref(null);
    const currTab = ref(null);
    const tabs = ref([]);
    const providerSearchCacheTtl = 60 * 1000;
    let providerSearchRequestId = 0;

    // vue router
    const { routeToTab } = useModuleNavigation();

    // start
    onMounted(() => {
      // page name
      document.title = "All Providers";
    });

    // menu
    onMounted(() => {
      // load tab
      tabs.value.push({ id: 1, name: "Providers", title: "All", icon: null, url: "provider", hash: null, });
      tabs.value.push({ id: 2, name: "Providers", title: "View", icon: "visibility", url: "provider", hash: "#view", });
      tabs.value.push({ id: 3, name: "Providers", title: "Add Provider", icon: "add_circle", url: "providerAdd", hash: null, });
      tabs.value.push({ id: 4, name: "Providers", title: "Sync", icon: "sync", url: "providerSync", hash: null, badge: null, });

      // set default
      currTab.value = tabs.value.find(x => x.id === 1);
      // set home
      home.value = tabs.value.find(x => x.id === 1);
    });

    // handle curr status
    const handleActive = (tab) => {
      routeToTab(tab, { replace: tab?.url === "provider" });
    };

    // numbering
    const numberBadge = (num) => {
      return (
        (allPages.value.current_page - 1) * allPages.value.per_page + num + 1
      );
    };

    // get function
    const getItemsFromApi = (table) => {
      (async () => {
        const { res, err } = await getItems(table);

        if (res.value) {
          response.value = res.value.data;
        } else {
          error.value = err.value;
        }

        // page is ready, loading is complete
        isReady.value = true;
        isLoading.value = false;
      })();
    };

    // starter
    onMounted(() => {
      // get items from function
      (async () => {
        const [readySync, waitingApproval] = await Promise.allSettled([
          getItems("integration/oneprovider/provider-sync/pending/count"),
          getItems("integration/oneprovider/provider-sync/registrations/pending/count"),
        ]);

        if (readySync.status === "fulfilled" && readySync.value.res.value) {
          syncInc.value = Number(readySync.value.res.value.data);
        }

        if (waitingApproval.status === "fulfilled" && waitingApproval.value.res.value) {
          pendingRegistrationInc.value = Number(waitingApproval.value.res.value.data);
        }

      })();
    });

    // starter
    onMounted(() => {
      // set current Url
      currUrl.value = "provider";
      // set current Hook
      currHook.value = "?";
      // get items from function
      getItemsFromApi(currUrl.value);
    });

    // restart
    const handleClearSearch = () => {
      providerSearchRequestId++;
      // start laoding
      isLoading.value = true;
      // null search
      searchItem.value = null;
      // set current Url
      currUrl.value = "provider";
      // set current Hook
      currHook.value = "?";
      // re-get items from function
      getItemsFromApi(currUrl.value);
    };

    const loadProviderSearch = debounce(async (query, requestId) => {
      if (requestId !== providerSearchRequestId || query !== searchItem.value?.trim()) {
        return;
      }

      const url = `provider/list/search?q=${encodeURIComponent(query)}`;
      const cachedPayload = getCachedPayload(url);

      if (cachedPayload) {
        response.value = cachedPayload;
        isReady.value = true;
        isLoading.value = false;
        return;
      }

      const { res, err } = await getItems(url);

      if (requestId !== providerSearchRequestId || query !== searchItem.value?.trim()) {
        return;
      }

      if (res.value) {
        response.value = res.value.data;
        setCachedPayload(url, res.value.data, providerSearchCacheTtl);
      } else {
        error.value = err.value;
      }

      isReady.value = true;
      isLoading.value = false;
    });

    // switch page
    const handlePage = (page) => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      // start laoding
      isReady.value = false;
      // get new page items from function
      getItemsFromApi(`${currUrl.value}${currHook.value}page=${page}`); //
    };

    // search watcher
    watch(searchItem, (value) => {
      const query = value?.trim() || "";
      providerSearchRequestId++;

      if (!query) {
        return;
      }

      if (query.length < 2) {
        isLoading.value = false;
        return;
      }

      // start laoding
      isLoading.value = true;
      // set current Url
      currUrl.value = `provider/list/search?q=${encodeURIComponent(query)}`;
      // set current Hook
      currHook.value = "&";
      // get searchItem items from function
      loadProviderSearch(query, providerSearchRequestId);
    });

    // output results
    const providers = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value.data;
      }
    });

    // output pages
    const allPages = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value; // get all
      }
    });

    const readySyncCount = computed(() => {
      return Number(syncInc.value || 0);
    });

    const awaitingOneProviderCount = computed(() => {
      return Number(pendingRegistrationInc.value || 0);
    });

    const providerSyncNoticeTotal = computed(() => {
      return readySyncCount.value + awaitingOneProviderCount.value;
    });

    watchEffect(() => {
      const syncTab = tabs.value.find(x => x.title === "Sync");

      if (!syncTab) return;

      const badge = providerSyncNoticeTotal.value || null;

      if (syncTab.badge !== badge) {
        syncTab.badge = badge;
      }
    });

    return {
      handleActive,
      home,
      currTab,
      tabs,
      numberBadge,
      handleClearSearch,
      handlePage,
      isReady,
      isLoading,
      error,
      syncInc,
      pendingRegistrationInc,
      searchItem,
      providers,
      allPages,
      readySyncCount,
      awaitingOneProviderCount,
      providerSyncNoticeTotal,
    };
  },
};
</script>

<style scoped>
.provider-page-surface {
  min-height: calc(100vh - 260px);
  padding-bottom: 56px;
  padding-top: 0;
}

.provider-client-surface,
.provider-client-surface.section {
  margin-top: -14px;
  padding-bottom: 0;
  padding-top: 0;
  position: relative;
  z-index: 1;
}

.provider-review-head,
.provider-search-card,
.provider-search-status,
.provider-client-card,
.provider-empty-state {
  box-sizing: border-box;
  width: 100%;
}

.provider-review-head,
.provider-search-card,
.provider-search-status,
.provider-client-card,
.provider-empty-state,
.provider-page-surface :deep(.pagination) {
  animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.provider-review-head {
  align-items: flex-end;
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px 6px 0 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  box-shadow: 0 12px 20px -18px rgba(38, 50, 56, 0.55);
  display: flex;
  gap: 22px;
  justify-content: space-between;
  margin-bottom: 0;
  overflow: visible;
  padding: 24px 26px;
  position: relative;
  z-index: 2;
}

.provider-review-head::before {
  border: 1px solid #c4d3d9;
  border-bottom: 0;
  border-radius: 7px 7px 0 0;
  content: "";
  height: 18px;
  left: -1px;
  pointer-events: none;
  position: absolute;
  right: -1px;
  top: -1px;
  z-index: 1;
}

.provider-title-block {
  position: relative;
  z-index: 2;
}

.provider-title-block h5 {
  color: #263238;
  font-weight: 700;
  margin: 4px 0 0;
}

.provider-title-block p {
  color: #607d8b;
  line-height: 1.45;
  margin: 6px 0 0;
  max-width: 720px;
}

.provider-add-link {
  align-items: center;
  background: #ffffff;
  border: 1px solid #80cbc4;
  border-radius: 999px;
  color: #00695c;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.82rem;
  font-weight: 700;
  gap: 8px;
  min-height: 40px;
  padding: 0 13px 0 16px;
  position: relative;
  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease, transform 0.18s ease;
  z-index: 2;
}

.provider-add-link:hover {
  background: #e0f2f1;
  border-color: #00897b;
  color: #004d40;
  transform: translateY(-1px);
}

.provider-add-link i {
  color: #00897b;
  font-size: 19px;
}

.provider-search-card {
  background: #f8fafb;
  border: 1px solid #c4d3d9;
  border-radius: 0 0 6px 6px;
  border-top: 0;
  box-shadow: 0 18px 34px -31px rgba(38, 50, 56, 0.78);
  margin-bottom: 16px;
  padding: 12px 16px;
}

.provider-search-card:has(+ .provider-search-status) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  box-shadow: none;
  margin-bottom: 0;
}

.provider-search-card form,
.provider-search-card .input-field {
  margin: 0;
}

.provider-search-card .input-field {
  position: relative;
}

.provider-search-card input[type="search"] {
  background: #ffffff;
  border: 1px solid #d5e1e5 !important;
  border-radius: 6px;
  box-sizing: border-box;
  box-shadow: none !important;
  color: #263238;
  font-weight: 600;
  height: 48px;
  line-height: 48px;
  margin: 0;
  padding-left: 46px;
  padding-right: 42px;
  width: 100%;
}

.provider-search-card input[type="search"]:focus {
  border-color: #80cbc4 !important;
  box-shadow: 0 0 0 3px rgba(128, 203, 196, 0.18) !important;
}

.provider-search-card .label-icon {
  align-items: center;
  display: flex;
  height: 48px;
  left: 10px;
  line-height: 48px;
  position: absolute;
  top: 0;
}

.provider-search-card .material-icons {
  color: #00897b;
  height: 48px;
  line-height: 48px;
}

.provider-search-card .input-field > i {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 48px;
  line-height: 48px;
  position: absolute;
  right: 10px;
  top: 0;
}

.provider-search-status {
  align-items: center;
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 0 0 6px 6px;
  border-top: 0;
  box-shadow: 0 16px 28px -24px rgba(38, 50, 56, 0.72);
  color: #263238;
  display: flex;
  justify-content: space-between;
  margin: 0 0 16px;
  padding: 12px 14px 12px 16px;
}

.provider-search-status span {
  color: #607d8b;
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 5px;
  text-transform: uppercase;
}

.provider-search-status strong {
  color: #263238;
  font-size: 0.98rem;
}

.provider-search-status button {
  align-items: center;
  background: #f7f7f7;
  border: 1px solid #e1e8eb;
  border-radius: 50%;
  color: #455a64;
  cursor: pointer;
  display: inline-flex;
  height: 32px;
  justify-content: center;
  padding: 0;
  width: 32px;
}

.provider-search-status button i {
  font-size: 18px;
}

.provider-client-card {
  background: linear-gradient(180deg, #ffffff 0%, #fdfdfd 100%);
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9), 0 18px 32px -30px rgba(38, 50, 56, 0.72) !important;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.provider-client-card:hover {
  border-color: #80cbc4;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9), 0 18px 32px -28px rgba(0, 105, 92, 0.34) !important;
  transform: translateY(-1px);
}

.provider-client-card .card-content {
  background: transparent;
}

.provider-client-card h5 {
  color: #263238;
  font-size: 1.22rem;
  font-weight: 700;
  line-height: 1.35;
  margin-top: 0;
}

.provider-client-card h5 a {
  color: #263238;
}

.provider-client-card h5 a:hover {
  color: #00897b;
}

.provider-client-card p {
  color: #455a64;
  margin-bottom: 0;
}

.provider-empty-state {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  box-shadow: 0 16px 28px -28px rgba(38, 50, 56, 0.72);
  color: #607d8b;
  margin-top: 16px;
  padding: 34px 20px;
}

.provider-empty-state i {
  align-items: center;
  background: #e0f2f1;
  border: 1px solid #80cbc4;
  border-radius: 50%;
  color: #00897b;
  display: inline-flex;
  font-size: 24px;
  height: 48px;
  justify-content: center;
  margin-bottom: 10px;
  width: 48px;
}

.provider-empty-state h6 {
  color: #263238;
  font-weight: 700;
  margin: 4px 0 6px;
}

.provider-empty-state p {
  margin: 0;
}

@media only screen and (max-width: 992px) {
  .provider-review-head {
    align-items: flex-start;
    flex-direction: column;
  }

  .provider-add-link {
    min-height: 42px;
  }
}

@media only screen and (max-width: 600px) {
  .provider-review-head {
    padding: 22px;
  }

  .provider-title-block h5 {
    font-size: 1.45rem;
  }

  .provider-title-block p {
    font-size: 0.94rem;
  }

  .provider-add-link {
    border-radius: 8px;
    justify-content: center;
    width: 100%;
  }

  .provider-search-card {
    padding: 10px;
  }

  .provider-search-status {
    align-items: flex-start;
    gap: 12px;
  }

  .provider-client-card {
    border-radius: 8px;
  }

  .provider-client-card .card-content {
    padding: 18px;
  }

  .provider-client-card h5 {
    display: flex;
    flex-direction: column;
    font-size: 1rem;
    gap: 8px;
  }

  .provider-client-card h5 .badge {
    align-self: flex-start;
    float: none;
    margin-left: 0;
    position: static;
  }

  .provider-client-card p {
    display: flex;
    flex-direction: column;
    font-size: 0.88rem;
    gap: 4px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .provider-review-head,
  .provider-search-card,
  .provider-search-status,
  .provider-client-card,
  .provider-empty-state,
  .provider-page-surface :deep(.pagination) {
    animation: none;
  }
}
</style>
